var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.348,
    height: 12.141,
    viewBox: "0 0 11.348 12.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "double-chevron-left",
    d: "M10.664.711,4.949-5.031a.256.256,0,0,1,0-.437l5.715-5.742a.3.3,0,0,1,.465,0l.547.547a.281.281,0,0,1,0,.465L6.727-5.25,11.676-.3a.281.281,0,0,1,0,.465l-.547.547A.3.3,0,0,1,10.664.711Zm-3.91,0a.3.3,0,0,1-.465,0L.574-5.031a.256.256,0,0,1,0-.437l5.715-5.742a.3.3,0,0,1,.465,0l.547.547a.281.281,0,0,1,0,.465L2.352-5.25,7.3-.3a.281.281,0,0,1,0,.465Z",
    transform: "translate(-0.451 11.32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronLeft);
export default __webpack_public_path__ + "static/media/double-chevron-left.3c3153997cd4a010b89537a39b2c765f.svg";
export { ForwardRef as ReactComponent };